export const TRANSLATION_KEYS = {
    Heading: "settingPage.groupPage.heading",
    SecondaryHeading: "settingPage.groupPage.secondaryHeading",
    BreadcrumbSettingHeading: "settingPage.heading",
    ColumnTitleLabel: "settingPage.groupPage.columnTitleLabel",
    ColumnEmailLabel: "settingPage.groupPage.columnEmailLabel",
    DetailsListEmptyContentLabel: "settingPage.groupPage.detailsListEmptyContentLabel",
};